export default "__VITE_ASSET__DnzA01ue__"